import(/* webpackMode: "eager" */ "/app/src/lib/context/checkout-context.tsx");
import(/* webpackMode: "eager" */ "/app/src/modules/layout/templates/footer/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/modules/layout/templates/header/index.tsx")